<script setup lang="ts">
import { onMounted } from 'vue';
import { useTabs } from '@/composables/tabs';
import isNumeric from '@/lib/is-numeric';
import ConnxTabButton from '../Atoms/Buttons/ConnxTabButton.vue';

interface Props {
  group?: string;
  tabContainerClass?: string;
  activeTab?: string | null;
}

const props = defineProps<Props>();
const { tabs, setActiveTab, activeTab } = useTabs(props.group);


const findTabSymbol = (searchingFor: string): symbol | null => {
  const tab = [...tabs].find((t) => t[1].hash === searchingFor || t[1].name === searchingFor);
  if (tab) {
    return tab[0];
  }
  return null;
};

onMounted(() => {
  if (props.activeTab) {
    const tabSymbol = findTabSymbol(props.activeTab);
    if (tabSymbol) {
      setActiveTab(tabSymbol);
      return;
    }
  }
  const params = new URLSearchParams(window.location.search);
  const activeTabParam = props.group ? params.get(props.group) : params.get('activeTab');

  if (!props.group && activeTabParam) {
    if (isNumeric(activeTabParam)) {
      const key = Number(activeTabParam);
      const activeTabKey = (activeTabParam && key <= tabs.size) ? (key - 1) : 0;
      const [identifier] = [...tabs][activeTabKey];
      setActiveTab(identifier);
    } else {
      const tabSymbol = findTabSymbol(activeTabParam);
      if (tabSymbol) {
        setActiveTab(tabSymbol);
      }
    }
  }
  if (props.group && activeTabParam) {
    const tabSymbol = findTabSymbol(activeTabParam);
    if (tabSymbol) {
      setActiveTab(tabSymbol);
    }
  }
  if (!activeTab.value) {
    setActiveTab([...tabs][0][0]);
  }
});

</script>

<template>
  <section>
    <ul class="tw-flex tw-border-solid tw-border-b tw-border-y-connx-grey-tint-65 tw-mt-4">
      <li
        v-for="[identifier, tabData] in tabs.entries()"
        :key="identifier"
        class="tw-mr-2"
        @click="setActiveTab(identifier)"
      >
        <connx-tab-button :active="identifier === activeTab">
          {{ tabData.name }}
        </connx-tab-button>
      </li>
    </ul>

    <div :class="tabContainerClass ?? 'tw-py-4'">
      <slot></slot>
    </div>
  </section>
</template>
